import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Status } from "../../constants/status";

export const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  color = "primary",
  isLoading = false,
  dialogState,
  onClose,
  loading = false,
  progress,
  action,
}) => {
  const state = dialogState || {};
  const finalOpen = open !== undefined ? open : !!state.open;
  const finalTitle = state.title || title;
  const finalMessage = state.message || message;
  const finalAction = state.action || action;
  const finalLoading = isLoading || loading;
  const finalOnCancel = onCancel || onClose;
  const finalColor =
    finalAction === Status.DELETE || finalAction === "delete" ? "error" : color;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(finalAction);
    }
  };

  if (!finalOpen && !dialogState) return null;

  return (
    <Dialog
      open={finalOpen}
      onClose={finalLoading ? undefined : finalOnCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
      >
        <Box
          sx={{
            display: "flex",
            p: 1,
            borderRadius: "50%",
            bgcolor: `${finalColor}.50`,
            color: `${finalColor}.main`,
          }}
        >
          <WarningAmberIcon />
        </Box>
        <Typography variant="h6" fontWeight={700}>
          {finalTitle}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          sx={{ color: "text.primary", mb: finalLoading ? 2 : 0 }}
        >
          {finalMessage}
        </DialogContentText>

        {finalLoading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 3,
            }}
          >
            <CircularProgress size={40} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              {progress
                ? `Processing records (${progress.current}/${progress.total})...`
                : "Processing..."}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={finalOnCancel}
          disabled={finalLoading}
          variant="outlined"
          color="inherit"
          sx={{ borderRadius: 2 }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={finalLoading}
          variant="contained"
          color={finalColor}
          autoFocus
          sx={{ borderRadius: 2, px: 3 }}
        >
          {finalLoading && !progress ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            confirmLabel
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
